/*
| Where an address or a transaction opens.
|
| Wallets open on this site's address page; transactions, and a wallet's raw
| on-chain view, open on the Sei block explorer.
*/

import { esc } from './format.js';

const WALLET = /^0x([0-9a-f]{40}|[0-9a-f]{64})$/i;
const ICON_ORIGIN = 'https://cdn.0xmonaco.com';

/** An icon URL on Monaco's CDN, or null: the page never fetches images from anywhere else. */
export function safeIconUrl(url) {
  try {
    const parsed = new URL(String(url ?? ''));
    return parsed.origin === ICON_ORIGIN ? parsed.href : null;
  } catch {
    return null;
  }
}

export function createLinks({ chainExplorerUrl }) {
  const base = String(chainExplorerUrl).replace(/\/+$/, '');

  return {
    external: false,
    address: (address) => (WALLET.test(String(address ?? '')) ? `/addresses/${String(address).toLowerCase()}` : null),
    chainAddress: (address) => `${base}/address/${encodeURIComponent(address)}`,
    transaction: (hash) => `${base}/tx/${encodeURIComponent(hash)}`,
  };
}

/** An anchor for a link that leaves the site. `html` is an already-escaped fragment. */
export function externalLink(href, html, className = '') {
  const cls = className ? ` class="${esc(className)}"` : '';
  return `<a${cls} href="${esc(href)}" target="_blank" rel="noopener noreferrer">${html}</a>`;
}

/** A wallet cell linked to its page here; anything that is not a wallet stays plain text. */
export function addressLink(links, address, html) {
  const href = links.address(address);
  return href ? `<a class="addr" href="${esc(href)}">${html}</a>` : html;
}
